import {Card, CardContent} from "@mui/material";
import {WithChildren} from "../../types/WithChildren";

interface props extends WithChildren {
  padding?: "sm" | "lg",
  background?: background
}

type background = "primary" | "secondary" | "tertiary"

export default function SteddiContainer({children, padding, background}: props) {

  function getColor(part?: background) {
    if (part === "secondary")
      return "secondary.main"
    if (part === "tertiary")
      return "container.main"
    if (part === "primary")
      return "primary.main"
    return "container.main"
  }

  function getTextColor(part?: background) {
    if (part === "secondary" || part === "tertiary")
      return "inherit"
    if (part === "primary")
      return "#FFF"
    return "inherit"
  }

  return (
    <Card elevation={0} sx={{width: "100%", bgcolor: getColor(background), color: getTextColor(background)}}>
      <CardContent style={{padding: padding && padding === "sm" ? 0 : 24}}>
        {children}
      </CardContent>
    </Card>
  )
}